<template>
    <div id="headline">
        <div class="CN">{{ $t('headLine',{CNtitle,ENtitle}) }}</div>
        <div class="line"></div>
        <!-- <div class="EN">{{ ENtitle }}</div> -->
    </div>
</template>

<script>

export default {
    name: 'headline',
    props: ['CNtitle','ENtitle'],
    components: {

    },
    data() {
        return {

        }
    },
}
</script>

<style lang="scss" scoped>
#headline {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2.5rem 0;
    .CN {
        font-size: 1.5rem;
        font-weight: bolder;
        display: flex;

        align-items: center;
        justify-content: center;
    }

    .line {
        height: 0.2rem;
        width: 1.5rem;
        background-color: #000000;
        margin: 1rem 0;
    }

    .EN {
        color: #939393;
        font-size: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>